/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'

import Card from '../_library/Card'
import Button from '../_library/Button'
import ConfirmModal from '../_library/ConfirmModal'
import { showAxiosError, showSuccessMessage } from '../utils/messenger'
import { Field, Form, Formik } from 'formik'
import { SimpleField } from '../formik/Fields'
import { combineValidators, isEmailValidator, requiredValidator } from '../../_common/core/validation'
import { createXenditAccount } from '../../_common/core/http_services'

const xenditButtonMessage =
  'The connected Xendit account will be the default payment method for all future events created under this Brand, but will not affect already created events.'

const PaymentMethodXendit = React.memo(props => {
  const { brand, isOwner } = props
  const [xenditData, setXenditData] = useState(null)
  const [isXenditModalOpen, setXenditModalOpen] = useState(false)
  const [isXenditConnectLoading, setXenditConnectLoading] = useState(false)

  useEffect(() => {
    setXenditData({ ...(brand?.xendit?.managedAccount || {}) })
  }, [brand])

  const showXenditStatus = !!xenditData?.status

  const handleXenditModalAction = async (action, values) => {
    switch (action) {
      case 'ok':
        try {
          setXenditConnectLoading(true)
          const res = await createXenditAccount(brand.id, values.xenditEmail)
          showSuccessMessage(res.message)
          setXenditModalOpen(false)
          setXenditConnectLoading(false)
          setXenditData({ status: 'INVITED' })
        } catch (e) {
          showAxiosError(e)
          setXenditConnectLoading(false)
        }
        break

      default:
        setXenditModalOpen(false)
        break
    }
  }

  return (
    <>
      <Formik
        enableReinitialize={false}
        initialValues={{ xenditEmail: '' }}
        onSubmit={values => handleXenditModalAction('ok', values)}
        render={({ values, errors }) => (
          <Form autoComplete="off">
            <ConfirmModal
              isOpen={isXenditModalOpen}
              header="Xendit Account Email"
              content={
                <div>
                  <Field
                    name="xenditEmail"
                    label="Email"
                    component={SimpleField}
                    touchedOnBlur
                    formclassname="field-wrapper"
                    validate={combineValidators(requiredValidator(), isEmailValidator())}
                  />
                </div>
              }
              actions={[
                {
                  value: 'ok',
                  label: 'Confirm',
                  className: 'btn btn-success btn-shadow',
                  disabled: !values.xenditEmail || errors.xenditEmail || isXenditConnectLoading,
                  loading: isXenditConnectLoading,
                },
                { value: 'cancel', label: 'Cancel', className: 'btn btn-cancel' },
              ]}
              classNames={{ container: 'modal-dialog modal-small' }}
              onAction={action => handleXenditModalAction(action, values)}
            />
          </Form>
        )}
      />
      <Card icon="fa-money" title="Payment Method" closed={false}>
        <div className="stripe-btn-message">
          <p>{xenditButtonMessage}</p>
        </div>
        {showXenditStatus ? (
          <div>
            <p>
              <strong>Status: </strong>
              {xenditData.status}
            </p>
          </div>
        ) : (
          <>
            {isOwner ? (
              <Button
                key="xendit-connect-button"
                className="btn btn-primary btn-lg btn-shadow"
                type="button"
                onClick={() => setXenditModalOpen(true)}
                loading={isXenditConnectLoading}
              >
                Connect Xendit Account
              </Button>
            ) : (
              <OverlayTrigger
                placement={'top'}
                overlay={
                  <Tooltip id="clipboardCopied">
                    An external Xendit account can only be connected by the Brand Owner.
                  </Tooltip>
                }
                trigger={['hover']}
              >
                <div style={{ width: '221px', padding: '12px' }}>
                  <Button
                    key="xendit-connect-button"
                    className="btn btn-primary btn-lg btn-shadow"
                    type="button"
                    disabled
                  >
                    Connect Xendit Account
                  </Button>
                </div>
              </OverlayTrigger>
            )}
          </>
        )}
      </Card>
    </>
  )
})

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethodXendit)
